interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  size?: 'sm' | 'md';
  color?: 'primary' | 'green';
  'aria-label'?: string;
}

const SIZE_CLASSES = {
  sm: { track: 'h-5 w-9', thumb: 'h-4 w-4', translate: 'translate-x-4' },
  md: { track: 'h-6 w-11', thumb: 'h-5 w-5', translate: 'translate-x-5' },
} as const;

const COLOR_CLASSES = {
  primary: 'bg-primary-600',
  green: 'bg-green-500',
} as const;

export function ToggleSwitch({
  checked,
  onChange,
  size = 'md',
  color = 'primary',
  'aria-label': ariaLabel,
}: ToggleSwitchProps) {
  const s = SIZE_CLASSES[size];

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={onChange}
      className={`relative inline-flex ${s.track} shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors ${
        checked ? COLOR_CLASSES[color] : 'bg-surface-200'
      }`}
    >
      <span
        className={`pointer-events-none inline-block ${s.thumb} rounded-full bg-white shadow ring-0 transition-transform ${
          checked ? s.translate : 'translate-x-0'
        }`}
      />
    </button>
  );
}
